import { Reducer } from 'redux';
import { RequestableDataWithEntityError } from 'src/store/types';
import { isType } from 'typescript-fsa';
import { getLoanAppForLendsmart } from 'src/store/loanapp/loanapp.selector';
import {
  loanApplicationRequest,
  loanApplicationRequestFail,
  loanApplicationRequestSuccess,
  loanApplicationRequestSuccessById,
  loanApplicationRequestFailById,
  loanApplicationRequestStart,
  setLoanAppInStore,
  updateLoanAppActions,
} from './loanapp.actions';

/**
 * State
 */
export type State = RequestableDataWithEntityError<any[]>;

export const defaultState: State = {
  loading: false,
  error: {},
  lastUpdated: 0,
  data: undefined,
};

/**
 * Reducer
 */
// @ts-ignore
const reducer: Reducer<State> = (state: State = defaultState, action) => {
  if (isType(action, loanApplicationRequest)) {
    return { ...state, loading: true };
  }

  if (isType(action, loanApplicationRequestSuccess)) {
    const { payload } = action;
    const { id, itemsById } = payload;
    return {
      ...state,
      loading: false,
      data: getLoanAppForLendsmart(itemsById, id),
      lastUpdated: Date.now(),
    };
  }

  if (isType(action, loanApplicationRequestStart)) {
    return {
      ...state,
      loading: true,
      data: {},
      lastUpdated: Date.now(),
    };
  }
  if (isType(action, loanApplicationRequestSuccessById)) {
    const { payload } = action;

    return {
      ...state,
      data: payload,
      loading: false,
      lastUpdated: Date.now(),
    };
  }
  if (isType(action, setLoanAppInStore)) {
    const { payload } = action;
    return {
      ...state,
      data: payload,
      loading: false,
      lastUpdated: Date.now(),
    };
  }
  if (isType(action, loanApplicationRequestFailById)) {
    const { payload } = action;
    return {
      ...state,
      loading: false,
      error: { ...state.error, read: payload },
    };
  }
  if (isType(action, loanApplicationRequestFail)) {
    const { payload } = action;

    return {
      ...state,
      loading: false,
      error: { ...state.error, read: payload },
    };
  }

  if (isType(action, updateLoanAppActions.done)) {
    const { payload } = action;
    return {
      ...state,
      loading: false,
      data: payload,
      lastUpdated: Date.now(),
    };
  }

  return state;
};

export default reducer;
